<template>

    <v-container fluid>
        <v-row>
            <v-col cols="2" md="3" sm="4" xs="12">
                <filter-box style="width: 100%"
                            v-model="filters"/>
            </v-col>
            <v-col cols="auto" md="9" sm="8" xs="12">
                <campaign-list :filters="filters"/>
            </v-col>
        </v-row>
        <router-view/>
    </v-container>
</template>

<script>
import FilterBox from "../components/campaignView/FilterBox";
import CampaignList from "../components/campaignView/CampaignList";

export default {
    name: "CampaignView",
    components: {CampaignList, FilterBox},
    data() {
        return {
            filters: {
                apps: ['bisecur', 'bluesecur', 'bluecontrol'],
                language: 'de',
                types: ['info', 'warning'],
            },
        };
    },
}
</script>

<style scoped>

</style>
